import request from '@/utils/request';
import { BASE_API, BASE_WENJUAN, WENJUAN_URL } from '@/utils/consts'

//预约明细月汇总
export function getReservationMonth(data) {
  return request(`${BASE_API}/reservation_item/month/list`,{
    method:'POST',
    data
  });
}

//  预约明细日汇总
export function getReservationDaily(data) {
  return request(`${BASE_API}/reservation_item/daily/list`,{
    method:'POST',
    data
  });
}